<div  *ngIf='hideHeader==false'>
    <h3 class="thankYou-Header">{{ 'callMeBack.thankYou' | translate}}</h3>

    <p class="thankYou-text">{{ data.subheading | translate}}</p>
    <div class="align-center img-thankYou">
        <!-- <img class="img-thankYou" aemNormalizeUrl src="../../../assets/img/illu@3x.svg" /> -->
        
        <qbe-illustration width="140px" class="img-thankYou"
        name="sent"
    ></qbe-illustration>
    </div>
</div>
<div *ngIf='hideHeader==true'>
    <div class="dialog-wrapper">
        <h3 class="thankYou-Header">{{ data.subheading | translate}}</h3>
    </div>
</div>
